<template>
  <el-dialog
    :title="!dataForm.id ? '新增' : '修改'"
    :modal-append-to-body="false"
    :show-close="false"
    :close-on-click-modal="false"
    :visible.sync="visible">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()" label-width="80px">
    <el-form-item label="操作用户" prop="username">
      <el-input v-model="dataForm.username" placeholder="操作用户"></el-input>
    </el-form-item>
    <el-form-item label="操作内容" prop="operation">
      <el-input v-model="dataForm.operation" placeholder="操作内容"></el-input>
    </el-form-item>
    <el-form-item label="耗时" prop="time">
      <el-input v-model="dataForm.time" placeholder="耗时"></el-input>
    </el-form-item>
    <el-form-item label="操作方法" prop="method">
      <el-input v-model="dataForm.method" placeholder="操作方法"></el-input>
    </el-form-item>
    <el-form-item label="方法参数" prop="params">
      <el-input v-model="dataForm.params" placeholder="方法参数"></el-input>
    </el-form-item>
    <el-form-item label="操作者IP" prop="ip">
      <el-input v-model="dataForm.ip" placeholder="操作者IP"></el-input>
    </el-form-item>
    <el-form-item label="创建时间" prop="createTime">
      <el-input v-model="dataForm.createTime" placeholder="创建时间"></el-input>
    </el-form-item>
    <el-form-item label="操作地点" prop="location">
      <el-input v-model="dataForm.location" placeholder="操作地点"></el-input>
    </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
  export default {
    data () {
      return {
        visible: false,
        dataForm: {
          id: 0,
          username: '',
          operation: '',
          time: '',
          method: '',
          params: '',
          ip: '',
          createTime: '',
          location: ''
        },
        dataRule: {
          username: [
            { required: true, message: '操作用户不能为空', trigger: 'blur' }
          ],
          operation: [
            { required: true, message: '操作内容不能为空', trigger: 'blur' }
          ],
          time: [
            { required: true, message: '耗时不能为空', trigger: 'blur' }
          ],
          method: [
            { required: true, message: '操作方法不能为空', trigger: 'blur' }
          ],
          params: [
            { required: true, message: '方法参数不能为空', trigger: 'blur' }
          ],
          ip: [
            { required: true, message: '操作者IP不能为空', trigger: 'blur' }
          ],
          createTime: [
            { required: true, message: '创建时间不能为空', trigger: 'blur' }
          ],
          location: [
            { required: true, message: '操作地点不能为空', trigger: 'blur' }
          ]
        }
      }
    },
    methods: {
      init (id) {
        this.dataForm.id = id || 0
        this.visible = true
        this.$nextTick(() => {
          this.$refs['dataForm'].resetFields()
          if (this.dataForm.id) {
            this.$http({
              url: this.$http.adornUrl(`/tlog/info/${this.dataForm.id}`),
              method: 'get',
              params: this.$http.adornParams()
            }).then(({data}) => {
              if (data && data.code === 200) {
                this.dataForm.username = data.tLog.username
                this.dataForm.operation = data.tLog.operation
                this.dataForm.time = data.tLog.time
                this.dataForm.method = data.tLog.method
                this.dataForm.params = data.tLog.params
                this.dataForm.ip = data.tLog.ip
                this.dataForm.createTime = data.tLog.createTime
                this.dataForm.location = data.tLog.location
              }
            })
          }
        })
      },
      // 表单提交
      dataFormSubmit () {
        this.$refs['dataForm'].validate((valid) => {
          if (valid) {
            this.$http({
              url: this.$http.adornUrl(`/tlog/${!this.dataForm.id ? 'save' : 'update'}`),
              method: 'post',
              data: this.$http.adornData({
                'id': this.dataForm.id || undefined,
                'username': this.dataForm.username,
                'operation': this.dataForm.operation,
                'time': this.dataForm.time,
                'method': this.dataForm.method,
                'params': this.dataForm.params,
                'ip': this.dataForm.ip,
                'createTime': this.dataForm.createTime,
                'location': this.dataForm.location
              })
            }).then(({data}) => {
              if (data && data.code === 200) {
                this.$message({
                  message: '操作成功',
                  type: 'success',
                  duration: 1000,
                  onClose: () => {
                    this.visible = false
                    this.$emit('refreshDataList')
                  }
                })
              } else {
                this.$message.error(data.msg)
              }
            })
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/backstagefunction/tlog-add-or-update.vue